<template>
  <v-form @submit.prevent="save" novalidate>
    <pr-box :title="titleBox">

      <div slot="buttons-header">
        <v-btn icon @click.native="goToList">
          <v-icon color="white">list</v-icon>
        </v-btn>
      </div>
      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-text-field label="Nome do Projeto" v-model="resource.name" :counter="100" required
            :error-messages="validationErrors.name">
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-text-field label="Nome do Responsável" v-model="resource.responsible_name" :counter="100" required
            :error-messages="validationErrors.responsible_name">
          </v-text-field>
        </v-flex>

        <v-flex xs12 md4>
          <v-text-field type="email" label="Email do Responsável" v-model="resource.responsible_email" :counter="100" required
            :error-messages="validationErrors.responsible_email">
          </v-text-field>
        </v-flex>

        <v-flex xs12 md4>
          <v-text-field
            label="Telefone do Responsável"
            v-model="resource.responsible_tel"
            required
            v-mask="['(##) ####-####', '(##) #####-####']"
            :error-messages="validationErrors.responsible_tel">
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 md12>
          <v-select
            :items="clients"
            item-text="name"
            item-value="id"
            hint="Vincular um cliente a este projeto"
            v-model="client"
            required
            return-object
            persistent-hint
            clearable
            :disabled="(clients.length === 0)"
            no-data-text="Nenhuma registro encontrado"
            placeholder="Selecione um cliente"
            :error-messages="validationErrors.client_id"></v-select>
        </v-flex>
      </v-layout>

      <v-alert
        :value="showAlert"
        type="error">
        Não existem clientes cadastrados no sistema.
      </v-alert>

      <div slot="buttons-footer">
        <v-btn flat type="submit" color="primary" :disabled="(clients.length === 0)" :loading="saveLoading">Salvar</v-btn>
      </div>
    </pr-box>
  </v-form>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import ProjectService from '@/features/project/ProjectService';
import ClientService from '@/features/client/ClientService';

export default {
  name: 'project-form',
  mixins: [CrudMixin],
  data() {
    return {
      showAlert: false,
      clients: [],
      client: {},
      clientService: new ClientService(),
    };
  },
  created() {
    this.clientService.query().then((data) => {
      this.clients = data;
      if (this.clients.length === 0) {
        this.showAlert = true;
      }
    });
  },
  methods: {
    initCrud() {
      this.serviceType = ProjectService;
      this.routerName = 'project';
      this.componentType = 'FORM';
    },
    beforeSave() {
      this.resource.client_id = this.client ? this.client.id : null;
    },
    afterLoadResource() {
      this.clients.push(this.resource.client);
      this.client = { id: this.resource.client.id, name: this.resource.client.name };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/project/ProjectForm.vue